import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';

export const useModalVisualization = () => {
    const dispatch = useDispatch();

    const { modalMode } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );

    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);

    return { modalMode, onCancel };
};
